import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'common-change-time-icon',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './change-time-icon.component.html',
  styleUrls: ['./change-time-icon.component.scss'],
})
export class ChangeTimeIconComponent {
  @Input() color!: string;
}
